/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import enlaceExterno from 'assets/enlace-externo.svg';

import { history } from 'store/ConfigureStore';
import { datosUsuarioLogueado } from 'constants/selectors';
import { enviarCodigoVerificacion } from 'services/apiServices';
import { TOTPActivate } from 'actions/mfa';

import ButtonSolid from 'components/ButtonSolid';
import Card from 'components/Card';
import {
  CONFIGURAR_EMAIL_LOGIN,
  POSTERGACION_2FA_LOGIN,
} from 'constants/RouterConstants';
import { ADVERTENCIA_MODAL_2FA } from 'constants/commonConstants';
import { startConfiguringSecondFactor } from 'actions/seguridad';

import styles from './styles.module.css';

const EnforceSecondFactor = () => {
  const dispatch = useDispatch();
  const usuario = useSelector(datosUsuarioLogueado);

  const [redirectUri, setRedirectUri] = useState();

  useEffect(() => {
    const { redirect_uri, state } = queryString.parse(history.location.search);
    if (redirect_uri && state) setRedirectUri(`${redirect_uri}&state=${state}`);
    history.replace(history.location.pathname);
  }, [history]);

  const handleConfigurarEmail = () => {
    dispatch(startConfiguringSecondFactor(redirectUri));
    enviarCodigoVerificacion();
    history.push(CONFIGURAR_EMAIL_LOGIN);
  };

  const handleConfigurarAplicativo = () => {
    dispatch(startConfiguringSecondFactor(redirectUri));
    dispatch(TOTPActivate(true));
  };

  const handleRechazar = () => {
    if (redirectUri) {
      // lo inicio para guardar redirect uri por si vuelve ciclicamente (necesito query param)
      dispatch(startConfiguringSecondFactor(redirectUri));
    }
    history.push(POSTERGACION_2FA_LOGIN);
  };

  return (
    <Card
      title="Activá el doble factor de autenticación"
      style={{ whiteSpace: 'pre-line' }}
    >
      <div className="subheading">{ADVERTENCIA_MODAL_2FA}</div>
      <div className={styles.container}>
        <div className={styles['button-container']}>
          <ButtonSolid
            text="Activar por correo"
            handleClick={handleConfigurarEmail}
          />
          <span>{`Recibirás un código a ${usuario?.user?.email}`}</span>
        </div>
        <div className={styles['button-container']}>
          <ButtonSolid
            text="Usar app de autenticación"
            handleClick={handleConfigurarAplicativo}
          />
          <span>
            Requiere configurar la aplicación de autenticación (recomendado)
          </span>
        </div>
        <div className={styles['button-container']}>
          <button
            type="button"
            onClick={handleRechazar}
            style={{
              lineHeight: '24px',
              textDecorationLine: 'underline',
              color: 'blue',
              padding: '8px 24px 8px 0',
            }}
          >
            Recordar más tarde
          </button>
        </div>
        <button
          type="button"
          onClick={() =>
            window.open(
              'https://www.gub.uy/agencia-gobierno-electronico-sociedad-informacion-conocimiento/comunicacion/publicaciones/doble-factor-autenticacion',
              '_blank',
            )
          }
          className={styles['link-segundo-factor']}
        >
          <span style={{ marginRight: '7px' }}>
            Conocer más sobre Doble Factor de Autenticación
          </span>
          <img
            src={enlaceExterno}
            alt="enlace externo"
            width="12"
            height="12"
          />
        </button>
      </div>
    </Card>
  );
};

export default EnforceSecondFactor;
